// extracted by mini-css-extract-plugin
export default {"genericCard":"Qr-z","inline":"Rr-z","mastercard":"Sr-z","discover":"Tr-z","visa":"Ur-z","amex":"Vr-z","active":"Wr-z"};